<template>
	<div class="top ">
		<div class="head">
			<div class="wd-container">
				<el-row type="flex" justify="space-between">
					<el-col :span="12">
						<el-row type="flex" justify="start">
							<el-col :span="12" class="wd-cursor" @click="selectaddr">
								<div class="selectaddrcss wd-flex wd-row-between ">
									<div class="wd-row-noshrink">送货至：</div>
									<el-cascader ref="addr" class="" v-model="logininfo.addrinfo" :options="options" style="width: 100%;" placeholder="请选择所在地区" @change="handleChange" />
								</div>
							</el-col>
							<el-col v-if="!logininfo.islogin">
								<span class="wd-cursor" @click="handleSelect('login')">登录</span>
								<span class="wd-m-l-10">|</span>
								<span class="wd-m-l-10 wd-cursor" @click="handleSelect('reg')">注册</span>
							</el-col>
							<el-col v-else>
								<span class="wd-cursor" @click="handleSelect('Myinfo')">{{ logininfo.myinfo.name }} {{ logininfo.myinfo.mobile }}</span>
								<span class="wd-m-l-10">|</span>
								<span class="wd-m-l-10 wd-cursor" @click="handleSelect('loginout')">退出登录</span>
							</el-col>
						</el-row>
					</el-col>
					<el-col :span="12">
						<el-row type="flex" justify="end" class="top_r">
							<div class="a wd-cursor" @click="handleSelect('Orderlist')">我的订单</div>
							<div class="b"></div>
							<div class="a wd-cursor" @click="handleSelect('Historylist')">我的浏览</div>
							<div class="b"></div>
							<div class="a wd-cursor" @click="handleSelect('Favlist')">我的收藏</div>
							<div class="b"></div>
							<div class="a wd-cursor" @click="handleSelect('Help')">帮助中心</div>
							<div class="b"></div>
						</el-row>
					</el-col>
				</el-row>
			</div>
		</div>
		<div class="wd-container">
			<el-row type="flex" justify="space-between" class="search ">
				<div class="logo wd-cursor"><el-image v-if="!$weidajs.isEmpty(logininfo.companyinfo.logo)" :src="$wdpicurl(logininfo.companyinfo.logo)" fit="contain" class="logoimg" @click="handleSelect('index')"></el-image></div>
				<div class="ipt wd-row-grow wd-flex">
					<div class="wd-flex wd-row-between  wd-width-percent-100">
						<div class="ipt2 "><el-input placeholder="请输入商品名称或品牌搜索" class="" prefix-icon="el-icon-search" v-model="con" /></div>

						<div class="btn2" @click="handleSelect('search')">搜索</div>
					</div>
				</div>
				<div class="btn  wd-m-auto" @click="handleSelect('cart')">
					<i class="wd-icon wd-font-20">&#xe600;</i>
					<span class="wd-m-l-10">购物车</span>
				</div>
			</el-row>
		</div>
		<div class="wd-container wd-rela">
			<div class=" wd-flex wd-row-left classlist">
				<div class="classa wd-cursor" @click="handleSelect('index')">
					<i class="wd-icon wd-font-20">&#xe616;</i>
					<span class="wd-m-l-10">全部商品分类</span>
				</div>
				<div class="classb wd-flex wd-row-left">
					<div class="menu" :class="flag == 1 ? 'select' : ''" @click="handleSelect('index')">首页</div>
					<div class="menu" :class="flag == 2 ? 'select' : ''" @click="handleSelect('goodslist', '2','母婴城')">母婴城</div>
					<div class="menu" :class="flag == 3 ? 'select' : ''" @click="handleSelect('goodslist', '3','奶粉')">奶粉</div>
					<div class="menu" :class="flag == 4 ? 'select' : ''" @click="handleSelect('goodslist', '4','辅食')">辅食</div>
					<div class="menu" :class="flag == 5 ? 'select' : ''" @click="handleSelect('IntegralMall')">积分商城</div>
					<!-- <el-menu :default-active="$route.path" class="el-menu-demo" mode="horizontal" active-text-color="#FF4C4C" @select="handleSelect">
						<el-menu-item index="1" @click="handleSelect('index')">首页</el-menu-item>
						<el-menu-item index="2" @click="handleSelect('goodslist','2')">母婴城</el-menu-item>
						<el-menu-item index="3" @click="handleSelect('goodslist','3')">奶粉</el-menu-item>
						<el-menu-item index="4" @click="handleSelect('goodslist','4')">辅食</el-menu-item>
						<el-menu-item index="5" @click="handleSelect('IntegralMall')">积分商城</el-menu-item>
					</el-menu> -->
				</div>
			</div>
			<div class="classc" :class="[showmoreclass ? 'show' : 'hide']">
				<div class="list" v-if="classlist.length > 0">
					<div class="arow" v-for="(item, index) in classlist" :key="index" @select="handleSelect">
						<div class="detail">
							<span class="span">
								<router-link :to="{ path: '/goodslist', query: { contype: 3, classid: item.id,showname:item.name } }" tag="span">{{ item.name }}</router-link>
							</span>
						</div>
						<div class="detail_detail">
							<div v-if="item.brand != ''" class="wd-m-b-10">
								<router-link
									:to="{ path: '/goodslist', query: { contype: 7, con: brand.id,showname:brand.name } }"
									class="classbrand"
									v-for="(brand, bindex) in item.brand"
									:key="bindex"
									tag="span"
								>
									{{ brand.name }}>
								</router-link>
							</div>
							<div class=" wd-flex wd-row-left wd-flex-wrap wd-col-top">
								<div class="wd-width-100 wd-cursor wd-font-bold">
									<router-link :to="{ path: '/goodslist', query: { contype: 3, classid: item.id,showname:item.name } }" tag="span">全部</router-link>
								</div>
								<div class="row" v-for="(detail, indexd) in item.detail" :key="indexd">
									<router-link :to="{ path: '/goodslist', query: { contype: 3, classid: detail.id,showname:detail.name } }" tag="span">{{ detail.name }}</router-link>
								</div>
							</div>
						</div>
					</div>
				</div>
				<!-- <div class="detail_detail ">
					<div  v-for="(item, index) in classlist" :key="index" class="wd-flex wd-row-between wd-col-top">
						<div class="wd-width-100">
							全部
						</div>
						<div class=" wd-flex wd-row-left wd-flex-wrap wd-col-top" >
							<div class="row"  v-for="(detail,indexd) in item.detail" :key="indexd">
								{{detail.name}}	
							</div>
							
						</div>
					</div>
				</div> -->
				<!-- <div v-for="(item,index) in classlist" :key="index" class="detail">
					<div class="">{{item.name}}</div>
				</div> -->
			</div>
		</div>
	</div>
</template>

<script>
import { mapState } from 'vuex';
import { regionData, TextToCode } from 'element-china-area-data';
export default {
	name: 'Top',
	computed: {
		...mapState(['logininfo'])
	},
	props: {
		showmoreclass: {
			type: Boolean,
			default: false
		},
		flag: {
			type: String,
			default: '1'
		}
	},
	watch: {
		flag: function() {
			this.activeIndex = this.flag;
		}
	},
	data() {
		return {
			options: regionData,
			selectedOptions: [],
			companyname: '威达软件',
			companyurl: 'http://www.weida888.com',
			logourl: require('@/assets/logo.png'),
			activeIndex: '1',
			activeIndex2: '1',
			con: '',
			classlist: [],
			selectaddrshow: false
		};
	},
	methods: {
		handleChange(value) {
			localStorage.setItem("wd_addr",value);
			this.$store.commit("setaddrinfo",value);
		},
		selectaddr() {
			this.selectaddrshow = true;
		},
		handleSelect(type, flag = '',showname='') {
			if (type === 'login') {
				this.$router.push('/login');
			} else if (type === 'reg') {
				this.$router.push('/reg');
			} else if (type === 'search') {
				this.$router.push({ name: 'Goodslist', query: {flag:0, con: this.con,showname:this.con } });
			} else if (type === 'cart') {
				this.$router.push('/member/cart');
			} else if (type === 'Orderlist') {
				this.$router.push({ name: 'MemberIndex', params: { aflag: 'Orderlist' } });
			} else if (type === 'Favlist') {
				this.$router.push({ name: 'MemberIndex', params: { aflag: 'Favlist' } });
			} else if (type === 'Historylist') {
				this.$router.push({ name: 'MemberIndex', params: { aflag: 'Historylist' } });
			} else if (type === 'Myinfo') {
				this.$router.push({ name: 'MemberIndex', params: { aflag: 'Myinfo' } });
			} else if (type === 'IntegralMall') {
				this.$router.push({ name: 'IntegralMall' });
			} else if (type === 'goodslist') {
				this.$router.push({ name: 'Goodslist', query: { flag: flag,showname:showname,con:showname } });
			} else if (type === 'Help') {
				this.$router.push({ name: 'Help' });
			} else if (type === 'loginout') {
				this.$store.commit("loginout");
				this.$router.push('/');
			} else {
				this.$router.push('/');
			}
		},
		loadclass() {
			this.$wd_request('appgoodsclass')
				.then(data => {
					this.classlist = data.value;
				})
				.catch(() => {});
		},
		loadaddrdata() {
			this.addr_name = '';
			this.addr_mobile = '';
			this.addr_province = '';
			this.addr_other = '';
			this.addr_addr = '';
			this.addr_state = '0';
			
			var addrinfo=this.logininfo.addrinfo||"";
			if (this.$weidajs.isEmpty(addrinfo)){
				addrinfo=localStorage.getItem("wd_addr")||"";
				if (!this.$weidajs.isEmpty(addrinfo)){
					var arr = addrinfo.split(',');
					this.$store.commit("setaddrinfo",arr);
					return;
				}
			}else{
				this.$store.commit("setaddrinfo",addrinfo);
			}
			
			
			if (this.pid !== '') {
				let indata = {
					addrid: this.pid
				};
				this.$wd_request('defaultaddr', indata, true, '.addredit')
					.then(data => {
						console.log(data);
						var arr = [];
						var txt = data.value.province;
						arr = txt.split('-');
						var code = [];
						code[0] = TextToCode[arr[0]].code;
						code[1] = TextToCode[arr[0]][arr[1]].code;
						code[2] = TextToCode[arr[0]][arr[1]][arr[2]].code;
						localStorage.setItem("wd_addr",code);
						this.$store.commit("setaddrinfo",code);
					})
					.catch(() => {});
			}
		}
	},
	created() {
		this.activeIndex = this.flag;
		this.loadclass();
		this.loadaddrdata();
	}
};
</script>
<style lang="scss">
.selectaddrcss {
	.el-input__inner {
		background: transparent;
		border: none;
		// width: 200px;
		padding-left: 0;
	}
}
</style>
<style lang="scss" scoped>
.classlist {
	position: relative;
	.classa {
		display: block;
		width: 180px;
		padding-left: 30px;
		height: 50px;
		line-height: 50px;
		font-size: 18px;
		font-weight: bold;
		border-radius: 5px 5px 0 0;
		background: -webkit-linear-gradient(bottom, rgba(255, 76, 76, 1) 0%, rgba(255, 102, 102, 1) 100%);
		background: -o-linear-gradient(bottom, rgba(255, 76, 76, 1) 0%, rgba(255, 102, 102, 1) 100%);
		background: linear-gradient(to top, rgba(255, 76, 76, 1) 0%, rgba(255, 102, 102, 1) 100%);
		color: #fff;
		&:hover{
			display: block;
		}
	}
	.classb {
		margin-left: 10px;
		.menu {
			border-bottom-color: transparent;
			height: 60px;
			line-height: 60px;
			margin: 0;
			border-bottom: 2px solid transparent;
			color: #909399;
			height: 56px;
			line-height: 56px;
			font-size: 16px;
			padding: 0 20px;
			list-style: none;
			cursor: pointer;
			position: relative;
			transition: border-color 0.3s, background-color 0.3s, color 0.3s;
			box-sizing: border-box;
			white-space: nowrap;
			&:hover {
				color: $wd-theme;
				font-weight: 600;
			}
			&.select {
				color: $wd-theme;
				font-weight: 600;
				border-bottom: 2px solid $wd-theme;
			}
		}
	}
}
.classc {
	overflow: hidden;
	z-index: 100;
	position: absolute;
	top: 51px;
	width: 100%;
	&.show {
		display: block;
	}
	&.hide {
		display: none;
	}
	.list {
		background-color: #ffffff;
		height: 480px;
		width: 210px;
		.arow {
			&:hover {
				cursor: pointer;
				color: $wd-theme;
				.detail_detail {
					color: #666;
					display: block;
				}
			}
			.detail {
				border-bottom: 1px solid #f0f0f0;
				padding: 15px 20px;
				display: relative;
				.span {
					margin-left: 20px;
				}
			}
			.detail_detail {
				position: absolute;
				top: 6px;
				left: 210px;
				width: 900px;
				height: 440px;
				// overflow-y: scroll;
				background-color: #ffffff;
				display: none;
				box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
				z-index: 100;
				padding: 20px;
				.row {
					padding: 0 10px;
					margin-bottom: 10px;
					color: #666;
					border-left: 1px solid #e5e5e5;
					&:hover {
						cursor: pointer;
						color: $wd-theme;
					}
				}
				.classbrand {
					padding: 2px 8px;
					background-color: $wd-theme;
					color: #ffffff;
					margin-right: 10px;
					margin-bottom: 10px;
					display: inline-block;
				}
			}
		}
	}
}
.top {
	.head {
		height: 40px;
		line-height: 40px;
		background-color: #f0f0f0;
		color: #666666;
		.top_r {
			.a {
				padding: 0 10px;
			}
			.b {
				width: 1px;
				height: 12px;
				padding: 0;
				margin: 10px 2px 0;
				background: #dedede;
				overflow: hidden;
			}
		}
	}
	.search {
		height: 90px;
		padding-top: 10px;
		.logo {
			width: 160px;
			height: 60px;
			.logoimg {
				width: 160px;
				height: 60px;
			}
		}
		.ipt {
			line-height: 60px;
			margin: 0 60px 0 30px;
			.ipt2 {
				height: 40px;
				line-height: 30px;
				font-size: 14px;
				border: 2px solid #ff4c4c;
				color: #666;
				border-radius: 20px 0 0 20px;
				padding-left: 20px;
				flex-grow: 1;
				::v-deep .el-input__inner {
					border: 0 !important;
				}
			}
			.btn2 {
				width: 80px;
				height: 44px;
				line-height: 44px;
				font-size: 18px;
				color: #fff;
				font-weight: bold;
				text-align: center;
				background: linear-gradient(0deg, rgba(255, 76, 76, 1) 0%, rgba(255, 102, 102, 1) 100%);
				cursor: pointer;
				border-radius: 0 20px 20px 0;
			}
		}
		.btn {
			position: relative;
			z-index: 9;
			width: 180px;
			height: 44px;
			line-height: 44px;
			background: linear-gradient(0deg, rgba(255, 76, 76, 1) 0%, rgba(255, 102, 102, 1) 100%);
			color: #fff;
			font-size: 18px;
			cursor: pointer;
			border-radius: 20px;
			text-align: center;
		}
	}
}
</style>
